import { 
  CLIENT_SET, 
  CLIENT_UNSET, 
  CLIENT_CHECK_TOKEN,
  CLIENT_CHECK_RIGHT_SUCCESS,
  CLIENT_SET_BROWSER_HISTORY,
  CLIENT_CHECK_RIGHT_ERROR } from './constants'

const initialSate = {
  id: null,
  token: null,
  brwHistory: {},
}

const reducer = function clientReducer (state = initialSate, action) {
  switch (action.type) {
    case CLIENT_SET:
      return {
        id: action.token.id,
        token: action.token.auth_token,
      }

    case CLIENT_SET_BROWSER_HISTORY:
      return {
        ...state,
        brwHistory: action.payload,
      }

    case CLIENT_UNSET:
      return {
        id: null,
        token: null,
      }

    case CLIENT_CHECK_TOKEN:
      return {
        id: null,
        token: null,
      }

    case CLIENT_CHECK_RIGHT_SUCCESS:
      return {
        is_right: action.data,
      }

    case CLIENT_CHECK_RIGHT_ERROR:
      return {
        is_right: false,
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/client/reducer.js